'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'gem';
var width = 512;
var height = 512;
var aliases = [128142];
var unicode = 'f3a5';
var svgPathData = 'M267 468.3L256 480l-11-11.7L0 208 112 32l288 0L512 208 267 468.3zM490 208l-234 0L22 208 256 456.7 490 208zm-7.2-16L393.1 51 273.3 192l209.6 0zM374.7 48L137.3 48 256 187.6 374.7 48zM118.9 51L29.1 192l209.6 0L118.9 51z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGem = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;